import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type FileStepContentWrapperProps = PropsWithChildren & {
  className?: string;
};

export const FileStepContentWrapper: FC<FileStepContentWrapperProps> = ({ className, children }) => (
  <div className={twMerge('border-solid border border-gray-200 rounded-lg p-6 overflow-y-auto max-h-[55dvh]', className)}>{children}</div>
);
